import { ReactNode } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@/shared/providers/ThemeProvider';
import { SearchProvider } from '@/shared/providers/ModalProvider';
import { GoogleDriveProvider } from '@/shared/providers/GoogleDriveProvider';
import { SyncProvider } from '@/features/sync/context/SyncProvider';
import { CustomToaster } from '@/shared/providers/Toaster';
import { TooltipProvider } from '@/shared/components/ui/tooltip';
import RefreshAppPrompt from '@/shared/components/RefreshAppPrompt';
import { AppProvider } from './AppProvider';

interface ProviderWrapperProps {
  children: ReactNode;
}

type ProviderWithProps = {
  Provider: React.FC<{ children: ReactNode }>;
  props?: Record<string, unknown>;
};

const providers: ProviderWithProps[] = [
  {
    Provider: Router,
    props: {},
  },
  {
    Provider: AppProvider,
    props: {},
  },
  {
    Provider: GoogleDriveProvider,
    props: {},
  },
  {
    Provider: SyncProvider,
    props: {},
  },
  {
    Provider: ThemeProvider,
    props: {
      defaultTheme: 'light' as const,
      storageKey: 'vite-ui-theme',
    },
  },
  {
    Provider: SearchProvider,
    props: {},
  },
  {
    Provider: TooltipProvider,
    props: {},
  },
];

export const ProviderWrapper: React.FC<ProviderWrapperProps> = ({ children }) => {
  return (
    <>
      {providers.reduceRight(
        (acc, { Provider, props = {} }) => (
          <Provider {...props}>{acc}</Provider>
        ),
        <>
          {children}
          <CustomToaster />
          <RefreshAppPrompt />
        </>
      )}
    </>
  );
};
